<template>
  <div>
    <h3 class="text-sm font-semibold tracking-wider text-gray-200 uppercase">
      {{ title }}
    </h3>
    <ul class="mt-4 space-y-4">
      <slot />
    </ul>
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
})
</script>
